import { instance } from '@/api/v2/instance';
import type { Survey } from '@/hooks/react-query/webinar';

import type { WebinarDto, WebinarPreviewDto } from './webinar.dto';
import type { WebinarUserDto, WebinarUserOrientation } from './webinarUser.dto';

export const getWebinar = async (
  title: string,
): Promise<{ webinar: WebinarDto; recommends: WebinarPreviewDto[] }> => {
  try {
    const rsp = await instance.get<WebinarDto>(`/webinar/title/${title}`);
    const recommends = await getWebinarPreviews(rsp.data.metadata.recommends);
    return {
      webinar: rsp.data,
      recommends,
    };
  } catch (e) {
    console.error('웨비나 조회 에러', e);
    throw e;
  }
};

export const getWebinarPreviews = async (
  titles: string[],
  status?: string,
): Promise<WebinarPreviewDto[]> => {
  const titleQuery = titles.map((title) => `title=${title}`).join('&');
  const statusQuery = status ? `status=${status}` : '';
  const query = `${titleQuery}&${statusQuery}`;
  try {
    const rsp = await instance.get<WebinarPreviewDto[]>(
      `/webinar/previews?${query}`,
      {
        params: {
          title: titles,
        },
      },
    );
    return rsp.data;
  } catch (e) {
    console.error('웨비나 요약 조회 에러', e);
    return e.response.data;
  }
};

export const getWebinarCarousel = async (): Promise<WebinarPreviewDto> => {
  try {
    const rsp = await instance.get<WebinarPreviewDto>(`/webinar/carousel`);
    return rsp.data;
  } catch (e) {
    console.error('웨비나 캐러셀 제목 조회 에러', e);
    return e.response.data;
  }
};

export const getWebinarUser = async (
  webinarId: string,
  onlineUserId: string,
): Promise<WebinarUserDto> => {
  try {
    const rsp = await instance.get<WebinarUserDto>(
      `/webinarUser/webinarId/${webinarId}/onlineUserId/${onlineUserId}`,
    );
    return rsp.data;
  } catch (e) {
    console.error('웨비나 조회 에러', e);
    return e.response.data;
  }
};

export const updateWebinarLike = async (
  webinarId: string,
  onlineUserId: string,
  targetLike: boolean,
): Promise<void> => {
  try {
    await instance.patch(`/webinar/like`, {
      webinarId,
      onlineUserId,
      like: targetLike,
    });
  } catch (e) {
    console.error('웨비나 좋아요 에러', e);
    return e.response.data;
  }
};
export const applyWebinar = async (
  webinarId: string,
  onlineUserId: string,
  name: string,
  phone: string,
  email: string,
  survey: Survey[],
  question: string,
): Promise<void> => {
  try {
    await instance.post(`/webinar/orientation`, {
      webinarId,
      onlineUserId,
      orientation: {
        webinarId,
        name,
        phone,
        email,
        survey,
        question,
      },
    });
  } catch (e) {
    console.error('웨비나 신청 에러', e);
    return e.response.data;
  }
};

export const updateWebinarUserOrientation = async (
  webinarId: string,
  onlineUserId: string,
  orientation: WebinarUserOrientation,
): Promise<void> => {
  try {
    await instance.patch(`/webinarUser/orientation`, {
      webinarId,
      onlineUserId,
      orientation,
    });
  } catch (e) {
    console.error('웨비나 신청 에러', e);
    return e.response.data;
  }
};
